import React from "react";
import { SvgBottom } from "./svg/SvgBottom";
import { SvgTop } from "./svg/SvgTop";

export const Viviendanovis = () => {
  return (
    <section className="viviendanovis_main" id="vivienda-novis">
      <div>
        <SvgTop />

        <article className="caja_blanca">
          <div className="viviendanovis_imgs">
            <figure className="imgs_content">
              <img
                src="./assets/img/mg2.webp"
                alt="Invertir en Colombia desde el exterior mediante leasing"
              />
            </figure>
          </div>

          <div className="viviendanovis_text">
            <div className="viviendanovis_content">
              <section>
                <div className="viviendanovis_title">
                  <h1>
                    Invertir en Colombia desde <span>el exterior</span>
                  </h1>
                  <h2>Leasing habitacional para vivienda No VIS</h2>
                </div>

                <div className="viviendanovis_paragraf">
                  <p>
                    El leasing habitacional es una alternativa para todos los bolsillos, para quien
                    compra por primera vez o para quien quiere invertir.
                  </p>
                  <p>
                    Financia tu casa a través de un contrato de arrendamiento con opción de compra
                    en el que cancelas un arriendo mensual y al finalizar el tiempo pactado, te
                    haces propietario del inmueble.
                  </p>
                </div>

                <div className="viviendanovis_derechos">
                  <ul>
                    <li>
                      Productos sujetos a políticas y condiciones de evaluación, aprobación y
                      desembolso del Banco Davivienda S.A
                    </li>
                    <li>
                      La tasa de interés es aplicable al momento del desembolso Consulte más
                      información sobre productos, servicios, tasas y tarifas en{" "}
                      <a href="www.davivienda.com">www.davivienda.com</a>{" "}
                    </li>
                  </ul>
                </div>

                <div className="viviendanovis_list">
                  <ul>
                    <li>
                      <button
                        onClick={() => {
                          window.open(
                            "https://api.whatsapp.com/send/?phone=+573105653998",
                            "_blank"
                          );
                        }}
                      >
                        Hablar con <span>un asesor</span>{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </section>
            </div>
          </div>
        </article>
        <SvgBottom />
      </div>
    </section>
  );
};
